<template>

<div>
    <div style="width:20%;float:left;">
        <el-table
            text-align="center"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
            v-loading="loading"
            ref="multipleTable"
            :data="data"
            :header-cell-style="{background:'#F4F4F5',color:'#606266'}">
            <el-table-column
                class="tableBox"
                style="width:40px;"
                label="观点管理"
                fixed="right">
                <!-- <template  slot-scope="scope" >
                    {{ scope.row.title | ellipsis }}
                    <span style="float:right;"> {{ scope.row.new_num }} </span>
                </template> -->
                <el-badge slot-scope="scope" :value="scope.row.new_num" class="item"  style="line-height:50px;" >
                    <div @click="findComment(scope.row.find_id)" :class="scope.row.find_id == query.find_id ?'activeBackgorundColor':''"  >{{ scope.row.title | ellipsis }}  </div>
                </el-badge>
            </el-table-column>   
        </el-table>
        <el-pagination class="pagination-container"
            style="height:50px;"
            background
            :page-size="page_size"            
            @current-change="handleCurrentChange"
            layout="total,prev, pager, next"
            :total="total"
            :current-page.sync="query.page">
        </el-pagination>
    </div>
    <div style="width:80%;float:left;" class="tabLeft">
        <el-table
            @click="dow(scope.row.cate_id)"
            text-align="center"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
            v-loading="loading"
            ref="multipleTable"
            :data="datass"
            :header-cell-style="{background:'#F4F4F5',color:'#606266'}">
            <!-- <el-table-column align="center" label="观点ID" prop="id"> </el-table-column> -->
            <el-table-column align="center" width="30px"  >
            </el-table-column>
            <el-table-column align="center" label="昵称" width="180px"  >
                 <template  slot-scope="scope"  >
                     <el-button type="text" size="small" @click.native="dow(scope.row)">
                     <span v-if="scope.row.is_anonymous == 1">{{ scope.row.nick }}<span  style="color:rgb(236, 150, 45)">(匿名)</span></span>
                     <span @click="userInfo()" v-else-if="scope.row.is_examine == 1"> {{ scope.row.ex_nick }} <span  style="color:rgb(236, 150, 45)">(未审核)</span></span>
                     <span @click="userInfo()" v-else-if="scope.row.is_examine == 3"> {{ scope.row.ex_nick }} <span  style="color:rgb(236, 150, 45)">(审核不通过)</span></span>
                     <span v-else> {{ scope.row.nick }}</span>
                     </el-button>
                     <p>{{ scope.row.create_time }}</p>
                </template>
            </el-table-column>
            <el-table-column
                width="150px"
                label="头像"
                prop="image"
                align="center"
                >
                <template slot-scope="scope" >       
                    <img :src="scope.row.ex_image"  min-width="80" height="80" />
                    <!-- <img v-if="scope.row.is_examine == 1" :src="scope.row.ex_image"  min-width="80" height="80" />     
                    <img v-else :src="scope.row.image"  min-width="80" height="80" /> -->
                </template> 
            </el-table-column>
            <el-table-column align="center" label="简介" prop="ex_autograph"></el-table-column>
            <el-table-column align="left" label="观点内容" width="500px" style="" prop="content"></el-table-column>
            <!-- <el-table-column align="center" label="评论时间" prop="create_time"></el-table-column> -->
            <el-table-column
                align="center"
                label="审核"
                fixed="right">
                <template  slot-scope="scope" >
                    <span v-if="scope.row.content == ''" >
                        <el-button type="text" style="color:gray" size="small" @click.native="Examine(scope.row.from_uid,scope.row.id,2)" ><span :class="scope.row.is_examine===2 ?'activeColor':''">用户放行</span></el-button>
                        <el-button type="text" style="color:gray" size="small" @click.native="Examine(scope.row.from_uid,scope.row.id,3)" ><span :class="scope.row.is_examine===3 ?'activeColor':''">审核不通过</span></el-button>
                    </span>
                    <span v-else>
                        <el-button type="text" style="color:gray" size="small" @click.native="ConnectExamine(scope.row.id,scope.row.is_release,scope.row.is_release,'is_release')" ><span :class="scope.row.is_release===1?'activeColor':''">放行</span></el-button>
                        <el-button type="text" style="color:gray" size="small" @click.native="ConnectExamine(scope.row.id,scope.row.is_release,scope.row.is_top,'is_top')"  ><span :class="scope.row.is_top===1?'activeColor':''">置顶</span></el-button>
                        <el-button type="text" style="color:gray" size="small" @click.native="ConnectExamine(scope.row.id,scope.row.is_release,scope.row.is_fold,'is_fold')" ><span :class="scope.row.is_fold===1?'activeColor':''">折叠</span></el-button>
                        <el-button type="text" style="color:gray" size="small" @click.native="ConnectExamine(scope.row.id,scope.row.is_release,scope.row.is_abbreviate,'is_abbreviate')" ><span :class="scope.row.is_abbreviate===1?'activeColor':''">缩略</span></el-button>
                    </span>
                    
                </template>
            </el-table-column>
        </el-table>

        <el-pagination class="pagination-container"
            style="height:50px;"
            background
            :page-size="page_size"            
            @current-change="handleCurrentChangeTwo"
            layout="total,prev, pager, next"
            :total="total2"
            :current-page.sync="query2.page">
        </el-pagination>

    </div>
</div>

</template>
<script>
import { cateExamineList, cateExamineCommentList, userSaveExamine, ContentExamine} from "../../api/category/category";
export default {
    data() {
        return {
            page: 1,
            loading: true,
            searchUsersType: "id",
            total: 0,
            page_size: 10,
            currentPage: 1,
            query: {
                page:'1',
                find_id: ''
            },
            query2: {
                page:'1',
                find_id: ''
            },
            data: [],
            datass: [],
            multipleSelection:[],
            multipleSelectionTwo:[],
            switchData: [],
            timer: '',
            total2: 0,
            new_state: '',
        };
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleSelectionChangeTwo(val) {
            this.multipleSelectionTwo = val;
        },
        handleCurrentChange(val) {
            this.query.page = val;
            sessionStorage.setItem( "currentPage_findList", val);
            // scrollTo(0, 800);
            this.getData();
        },
        handleCurrentChangeTwo(val) {
            this.query2.page = val;
            sessionStorage.setItem( "currentPage_findList", val);
            // scrollTo(0, 800);
            this.findComment(this.query2.find_id);
        },
        getData() {
            cateExamineList(this.query).then(response => {
                this.data = response.data.data || [];
                this.loading = false;
                this.total = response.data.total;
            }).catch(() => {
                this.loading = false;
                this.data = [];
                this.total = 0;
            });
        },
        handleForm(index,row) {
            this.$router.push({
                path: "/posting/postingDetail",
                query: {
                    find_id: row
                }
            });
        },
        // 显示表单
        handleForm2(index,row) {
            this.$router.push({
                path: "/posting/postingComment",
                query: {
                    find_id: row
                }
            });
        },
        findComment(find_id){
            this.query.find_id = find_id
            this.query2.find_id = find_id
            cateExamineCommentList(this.query2).then(response => {
                this.datass = response.data.data || [];
                this.loading = false;
                this.total2 = response.data.total;
                this.getData();
            }).catch(() => {
                this.loading = false;
                this.datass = [];
                this.total2 = 0;
            });
        },
        // 用户放行
        Examine(user_id,find_comment_id,state){
            this.examineDataTo = {'user_id':user_id,'is_examine':state,'find_comment_id':find_comment_id};
            userSaveExamine(this.examineDataTo)
                .then(response => {
                    // console.log(response);
                    if (response.code != 0) {
                        this.$message.error(response.msg);
                        return false;
                    } else {
                        this.$message.success("操作成功");
                        this.findComment(this.query.find_id);
                    }
                })
                .catch(() => {
                    this.deleteLoading = false;
                });
        },
        // 观点审核操作
        ConnectExamine(id,is_release_status,state,type) {
            if (state ==1) this.new_state = 2
            if (state ==2) this.new_state = 1
            var state = !state
            this.examineData = {'id':id,'state':this.new_state,'type':type};
            ContentExamine(this.examineData)
                .then(response => {
                    if (response.code != 0) {
                        this.$message.error(response.msg);
                        return false;
                    } else {
                        console.log(response,'结果')
                        this.$message.success("操作成功！");
                        this.findComment(this.query.find_id);
                    }
                })
                .catch(() => {
                    this.deleteLoading = false;
                });
        },
        // 用户跳转详情
        dow(row) {
            this.$router.push({ path: `/userManage/customerManage/normalUsers/${row.from_uid}` });
        },
    },
    filters: {
        ellipsis (value) {
            if (!value) return ''
            if (value.length > 18) {
                return value.slice(0,18) + '...'
            }
            return value
        },
        statusFilterName(status) {
            const statusMap = {
                1: "普通用户",
                2: "医生",
                3: "咨询师",
                4: "医院",
                5: "未确定"
            };
            return statusMap[status];
        }
    },
    mounted() {
        this.timer = setInterval(this.getData, 60000);
    },
    created() {
        this.query.page = 1;
        // this.query.page = Number(sessionStorage.getItem("currentPage_findList")) || 1;
        this.getData();
    }
};
</script>
<style >
.el-table td div {
    width: 100%;
}
.el-badge__content.is-fixed {
    top: 15px !important;
    right: 15px !important;
    height: auto !important;
}
.el-table td {
    padding: 0 !important;
}
 .activeColor{
     color:rgb(129, 221, 68);
 }
  .activeBackgorundColor{
     background:rgb(187, 190, 183);
     color: black
 }
 
  .tabLeft tbody .cell {
      margin-top: 20px;
     margin-bottom: 20px;
     line-height: 180%
  }
</style>
